import React, { createRef, Fragment, FunctionComponent, useState } from "react";
import styles from "./VideoViewer.module.scss";
import VideoViewerProps from "./VideoViewerProps.interface";

import combineClasses from "helpers/combine-classes";
import setFileOptions from "app/media/helpers/setFileOptions";
import IconViewer from "components/IconViewer/IconViewer";

const VideoViewer: FunctionComponent<VideoViewerProps> = (props) => {
    const videoUrl = setFileOptions(props.src);
    const video = createRef<HTMLVideoElement>();

    const isAutoplay = props.autoplay ? props.autoplay : false;
    const isLoop = props.loop ? props.loop : false;
    const showControls = props.controls ? props.controls : false;

    const [isPlaying, setIsPlaying] = useState(false);
    const isPlayingClass = isPlaying === true ? styles.is_playing : undefined;

    const toggleVideoHandler = () => {
        const videoCurrent = video.current;
        setIsPlaying(!isPlaying);

        //Plays or pauses the current video
        { videoCurrent && !isPlaying ? videoCurrent?.play() : videoCurrent?.pause(); }
    };

    const onLoadStartHandler = (event: any) => {
        if (event && event.target)
            event.target.volume = isAutoplay ? 0 : 1;
    };

    return (
        <Fragment>
            <div className={combineClasses([styles.wrapper, props.className])}>
                {props.src ? (
                    <video className={styles.video} controls={(isAutoplay && showControls) || (!isAutoplay && isPlaying)} autoPlay={isAutoplay} loop={isLoop} playsInline={isAutoplay} muted={isAutoplay} ref={video} onLoadStart={onLoadStartHandler}>
                        <source src={videoUrl} type="video/mp4" />
                        {props.alt}
                    </video>
                ) : null}

                {!isAutoplay ? (
                    <div className={combineClasses([styles.button_wrapper, isPlayingClass])} onClick={() => toggleVideoHandler()}>
                        <button aria-label="Play / Pause Video" type="button" className={styles.button}>
                            {!isPlaying ? (
                                <IconViewer name="play" className={styles.icon_play} />
                            ) : (
                                <IconViewer name="pause" className={styles.icon_pause} />
                            )}
                        </button>
                    </div>
                ) : null}

                {typeof (props.aspectRatioX) !== "undefined" && typeof (props.aspectRatioY) !== "undefined" ? (
                    <svg viewBox={`0 0 ${props.aspectRatioX} ${props.aspectRatioY}`} version="1.1" className={styles.ratio} preserveAspectRatio="xMidYMid" xmlSpace="preserve"></svg>
                ) : null}
            </div>
        </Fragment>
    );
};

export default VideoViewer;